(function () {
  function initializeRouter(root) {
    if (!root || root.dataset.ecRouterReady === "true") return;

    var cardList = root.querySelector("[data-ec-router-cards]");
    var buttons = Array.prototype.slice.call(root.querySelectorAll("[data-ec-router-option]"));
    var cards = Array.prototype.slice.call(root.querySelectorAll("[data-ec-router-card]"));
    var result = root.querySelector("[data-ec-router-result]");

    if (!cardList || !buttons.length || !cards.length) return;
    root.dataset.ecRouterReady = "true";

    buttons.forEach(function (button) {
      button.addEventListener("click", function () {
        var route = button.getAttribute("data-ec-router-option") || "all";
        var message = button.getAttribute("data-result") || "Compare the routes below.";

        buttons.forEach(function (candidate) {
          var selected = candidate === button;
          candidate.classList.toggle("is-active", selected);
          candidate.setAttribute("aria-pressed", String(selected));
        });

        cards.forEach(function (card) {
          card.classList.toggle(
            "is-recommended",
            route !== "all" && card.getAttribute("data-product") === route
          );
        });

        cardList.classList.toggle("has-selection", route !== "all");
        if (result) result.textContent = message;

        if (route !== "all" && window.matchMedia("(max-width: 620px)").matches) {
          var matchedCard = root.querySelector('[data-product="' + route + '"]');
          if (matchedCard) {
            matchedCard.scrollIntoView({ behavior: "smooth", block: "start" });
          }
        }
      });
    });
  }

  function initializeAll(scope) {
    var searchRoot = scope && scope.querySelectorAll ? scope : document;
    Array.prototype.slice.call(searchRoot.querySelectorAll("[data-ec-home-router]")).forEach(initializeRouter);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { initializeAll(document); });
  } else {
    initializeAll(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    initializeAll(event.target);
  });
})();
